<template>
  <div v-if="isLoggedIn" class="wdw-login-header">
    <div class="btn-group">
      <template v-if="userComponentUri">
        <a :href="userComponentUri" class="btn btn-primary btn-profile" tabindex="0" role="link">
          <font-awesome-icon icon="user" aria-hidden="true" />
          <span class="visually-hidden">Profil öffnen</span>
          {{ user.public_name }}
        </a>
      </template>
      <template v-else>
        <a class="btn btn-primary btn-profile-disabled" tabindex="-1" disabled>{{ user.public_name }}</a>
      </template>
      <button class="btn btn-secondary btn-logout" @click="logout" tabindex="0" role="link">
        <font-awesome-icon icon="sign-out-alt" aria-hidden="true" />
        Logout
      </button>
    </div>
  </div>
  <div v-else class="wdw-login-header">
    <button type="button" class="btn btn-primary btn-login" @click="showLogin">
      <font-awesome-icon icon="sign-in-alt" />
      Login/Registrieren
    </button>
    <OverlayPanel
      v-if="!isLoggedIn"
      ref="loginOP"
      :showCloseIcon="true"
      :dismissable="true"
      appendTo="body"
      class="wdw-widgets"
    >
      <Login
        :domainid="domainid"
        :handleEventsInParent="Boolean(userComponentUri)"
        @open-registration="openRegistration()"
        @open-pw-request="openRequestPassword()"
      />
    </OverlayPanel>
  </div>
</template>

<script>
import { userStore } from '@/store/user-store';
import { domainStore } from '@/store/domain-store';
import Login from '@/components/user/Login.vue';
import OverlayPanel from 'primevue/overlaypanel';
import useAuthentication from '@/composables/user/useAuthentication';
import { onBeforeMount, onMounted, reactive, ref, computed } from 'vue';
import { RepositoryFactory } from '@/api/repositoryFactory';
const AuthRepository = RepositoryFactory.get('auth');

export default {
  name: 'LoginHeader',
  props: {
    domainid: {
      type: Number,
      required: true,
    },
    profileUri: {
      type: String,
      required: false,
    },
  },

  setup(props) {
    onBeforeMount(() => {
      domainStore.setDomainId(props.domainid);
    });
    const { initStorageAuthToken, setAuthToken } = useAuthentication();
    const loginOP = ref();

    //computed
    const user = computed(() => {
      return userStore.getState().user;
    });
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });
    const domain = computed(() => {
      return domainStore.getState().domain;
    });
    const userComponentUri = computed(() => {
      if (props.profileUri) {
        return props.profileUri;
      } else if (domain.value && domain.value.widget_links && domain.value.widget_links.user_component) {
        return domain.value.widget_links.user_component;
      }
      return false;
    });

    function getCurrentUri() {
      return window.location.origin + window.location.pathname;
    }
    function showLogin(event) {
      loginOP.value.show(event);
    }

    function openRegistration(event) {
      if (userComponentUri.value) {
        window.location = userComponentUri.value + '#/?register=true';
        loginOP.value.hide(event);
      }
    }
    function openRequestPassword(event) {
      if (userComponentUri.value) {
        window.location = userComponentUri.value + '#/?request_password=true';
        loginOP.value.hide(event);
      }
    }

    const logout = () => {
      if (process.env.VUE_APP_INTERNAL_COOKIE_USE) {
        // server-logout via redirect
        document.location.href = '/logout?referer=' + getCurrentUri();
      } else {
        AuthRepository.logout(userStore.getState().authToken)
          .then(response => {
            if (response && response.data.success && response.data.data) {
              setAuthToken();
            }
          })
          .catch(error => {
            console.error(error.response);
            // reset on error anyway
            setAuthToken();
          });
      }
    };

    return {
      logout,
      user,
      isLoggedIn,
      loginOP,
      userComponentUri,
      showLogin,
      openRegistration,
      openRequestPassword,
    };
  },

  components: {
    OverlayPanel,
    Login,
  },
};
</script>

<style scoped></style>
